export const PATH_NODE_CARD_WIDTH = 240
export const PATH_NODE_CARD_TOP_OFFSET = 5
export const PATH_NODE_CARD_LEFT_OFFSET = 7
